module.exports = __webpack_public_path__ + "img/us_inactive@2x.78d2242c.png";